<script setup lang="ts">
import { UiTextButton } from "@packages/component-library";
import { computed, onMounted, Ref, ref } from "vue";
import { useWindowSize } from "@vueuse/core";
import { useI18n } from "vue-i18n";

defineProps({
  text: {
    type: String,
    default: "",
  },

  lines: {
    type: [String, Number],
    default: 3,
  },
});

const showMoreButton = ref(false);
const showText = ref(false);
const { width } = useWindowSize();
const { t } = useI18n();

const el: Ref<HTMLDivElement | null> = ref(null);
const defaultTextHeight = computed(() => el.value?.scrollHeight);

onMounted(() => {
  if (width.value > 1023 && defaultTextHeight.value > 80) {
    showMoreButton.value = true;
  }
  if (width.value < 1024 && defaultTextHeight.value > 60) {
    showMoreButton.value = true;
  }
});
</script>

<template>
  <div class="show-more-text">
    <p v-if="!showText" ref="el" :style="`--lines: ${lines}`" v-html="text" />

    <p v-else v-html="text" />

    <UiTextButton
      v-if="showMoreButton"
      :label="showText ? t('system.hide') : t('system.more')"
      size="m"
      @click="showText = !showText"
    />
  </div>
</template>

<style scoped lang="scss">
.show-more-text {
  > button {
    margin: calc($base-space) 0 0;
  }

  > p {
    white-space: pre-line;
    display: -webkit-box;
    max-width: 100%;
    -webkit-line-clamp: var(--lines);
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    @include body-m();
    color: var(--color-semantic-content-normal-primary);
    word-break: break-word;

    &:deep(ol) {
      list-style: decimal;
      margin: 0 0 0 calc($base-space * 5);
    }

    &:deep(ul) {
      list-style: disc;
      margin: 0 0 0 calc($base-space * 5);
    }
  }
}
</style>
